import React, { useEffect } from 'react';
import { isValidCardNumber, isValidCvc } from 'utilities/validators';
import { setCardCvc, setCardHolderName, setCardNo } from 'actions/NewPaymentMethod';
import ExpirationDateInput from 'components/Payment/ExpirationDateInput';
import InputRow from 'components/UI/InputRow';
import TextInput from 'components/UI/TextInput';
import { cardFormat } from 'utilities/text';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
function NewPaymentMethodForm() {
    // Redux
    const { cardHolderName, cardNo, cvc } = useSelector(({ newPaymentMethod }) => newPaymentMethod);
    const { firstName, lastName } = useSelector(({ personalInfo }) => personalInfo);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    // If user has entered their name and no card name has been entered,
    // pre-fill the card holder name
    useEffect(() => {
        if (firstName && lastName && cardHolderName.length == 0) {
            dispatch(setCardHolderName(`${firstName} ${lastName}`));
        }
    }, []);
    return (React.createElement("div", { className: "new-payment-method-form" },
        React.createElement(TextInput, { label: t('paymentNewPaymentMethodFormName'), value: cardHolderName, onChange: (val) => dispatch(setCardHolderName(val)), required: true }),
        React.createElement(TextInput, { className: "new-payment-method-form__card-number", label: t('paymentNewPaymentMethodFormCard'), type: "tel", value: cardFormat(cardNo), invalidHelp: t('paymentNewPaymentMethodFormCardInvalid'), maxLength: 19, validator: isValidCardNumber, onChange: (val) => dispatch(setCardNo(val)), required: true }),
        React.createElement(InputRow, null,
            React.createElement(ExpirationDateInput, null),
            React.createElement(TextInput, { className: "new-payment-method-form__cvc", label: "CVC", type: "tel", value: cvc, maxLength: 3, validator: isValidCvc, invalidHelp: t('paymentNewPaymentMethodFormCVCInvalid'), onChange: (val) => dispatch(setCardCvc(val)), required: true }))));
}
export default NewPaymentMethodForm;
